import http from './http'
export default class ContractApi{
	// 获取订单列表
	static findOrderList(data) {
		return http.httpPost('/contract/findOrderList', data)
	}
	// 备注合同
	static remarkContract(data) {
		return http.httpPost('/contract/remark', data)
	}
	// 获取合同列表
	static findContractList(data) {
		return http.httpPost('/contract/findContractList', data)
	}
	// 草稿作废
	static invalidContract(data) {
		return http.httpPost('/contract/invalidContract', data)
	}
	// 草稿转正式合同
	static generFormalContract(data) {
		return http.httpPost('/contract/generFormalContract', data)
	}
	// 生成草稿合同
	static generDraftContract(data) {
		return http.httpPost('/contract/generDraftContract', data)
	}
	// 获取验证码
	static sendMessageToTel(params) {
		return http.httpGet('/user/manager/sendMessageToTel', params)
	}
	// 校验验证码
	static checkMessageToTel(params) {
		return http.httpGet('/user/manager/checkMessageToTel', params)
	}
	// 预览
	static previewDraftContract(params) {
		return http.httpGet('/contract/previewDraftContract', params)
	}

	// 下载
	static downloadFormatContract(params) {
		return http.httpGet('/contract/downloadFormatContract', params)
	}
}
